<div class="menu">
    <!-- <div class="side-menu">
        <div class="content-center">
            <img src="../../../../assets/images/mati-name-icon.svg" alt="mati-name" width="95px" height="64px">
        </div>
        <div class="menu-item mt-56" [routerLink]="['/summary-dashboard']"
        [routerLinkActive]="['active']">
            <div class="img-circle">
                <img src="../../../../assets/images/dashboard-icon-1.svg" alt="dashboard-icon-1" class="img-1" width="24px" height="24px">
                <img src="../../../../assets/images/dashboard-icon-1.svg" alt="dashboard-icon-2" class="img-2" width="33px" height="33px">
                <img src="../../../../assets/images/dashboard-icon-3.svg" alt="dashboard-icon-3" class="img-3" width="33px" height="33px">
            </div>
            <div class="menu-title mt--4">
                Dashboard
            </div>
        </div>
        <ng-container>
            <div class="menu-item mt-40" [routerLink]="['/farm']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.farmApp">
                <div class="img-circle">
                    <img src="../../../../assets/images/farm-icon-1.svg" alt="farm-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/farm-icon-2.svg" alt="farm-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/farm-icon-3.svg" alt="farm-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    Farm app
                </div>
            </div>
            <div class="menu-item mt-40" [routerLink]="['/warehouse']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.warehouse">
                <div class="img-circle">
                    <img src="../../../../assets/images/warehouse-icon-1.svg" alt="Warehouse-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/warehouse-icon-2.svg" alt="Warehouse-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/warehouse-icon-3.svg" alt="Warehouse-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    Warehouse app
                </div>
            </div>
            <div class="menu-item mt-40" [routerLink]="['/supply']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.supplyDemand">
                <div class="img-circle">
                    <img src="../../../../assets/images/supply-icon-1.svg" alt="supply-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/supply-icon-1.svg" alt="supply-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/supply-icon-3.svg" alt="supply-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    Planning dashboard
                </div>
            </div>
            <div class="menu-item mt-40" [routerLink]="['/lab']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.labApp">
                <div class="img-circle">
                    <img src="../../../../assets/images/lab-1.svg" alt="lab-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/lab-2.svg" alt="lab-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/lab-3.svg" alt="lab-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    Lab app
                </div>
            </div>
            <div class="menu-item mt-40" [routerLink]="['/quality-check']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.qualityAccess">
                <div class="img-circle">
                    <img src="../../../../assets/images/quality-check-1.svg" alt="quality-check-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/quality-check-1.svg" alt="quality-check-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/quality-check-3.svg" alt="quality-check-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    Quality check
                </div>
            </div>
            <div class="menu-item mt-40" [routerLink]="['/hse']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.hseAccess">
                <div class="img-circle">
                    <img src="../../../../assets/images/hse-1.svg" alt="hse-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/hse-2.svg" alt="hse-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/hse-3.svg" alt="hse-icon-3" class="img-3" width="33px" height="33px">
                </div>
                <div class="menu-title mt--4">
                    HSE
                </div>
            </div>
            <div class="menu-item pull-bottom" data-toggle="modal" data-target="#switchModal">
                <div class="base-name">
                    {{currentBase.baseName}}
                </div>
                <hr style="border-top: 1px solid #FFF;margin: 0px;">
                <button type="button" class="switch-btn">
                    <img src="../../../../assets/images/reload-2.svg" alt="reload-2" width="16px" height="16px" >
                    Switch Base
                </button>
            </div>
        </ng-container>
    </div> -->
    <div class="side-menu-2">
        <div class="content-center">
            <img src="../../../../assets/images/mati-name-icon.svg" alt="mati-name" width="40px" height="26px">
        </div>
        <div class="menu-item mt-32" [routerLink]="['/summary-dashboard']"
        [routerLinkActive]="['active']">
            <div class="img-circle-1">
                <img src="../../../../assets/images/dashboard-icon-1.svg" alt="dashboard-icon-1" class="img-1" width="24px" height="24px">
                <img src="../../../../assets/images/dashboard-icon-2.svg" alt="dashboard-icon-2" class="img-2" width="33px" height="33px">
                <img src="../../../../assets/images/dashboard-icon-3.svg" alt="dashboard-icon-3" class="img-3" width="33px" height="33px">
                <div class="menu-title">
                    Dashboard
                </div>
            </div>
        </div>
        <!-- <div class="menu-item mt-56" [routerLink]="['/']"
        [routerLinkActive]="['active']" 
        [routerLinkActiveOptions]="{ exact: true }">
            <div class="img-circle-1">
                <img src="../../../../assets/images/dashboard-icon-1.svg" alt="dashboard-icon-1" class="img-1" width="24px" height="24px">
                <img src="../../../../assets/images/dashboard-icon-2.svg" alt="dashboard-icon-2" class="img-2" width="33px" height="33px">
                <img src="../../../../assets/images/dashboard-icon-3.svg" alt="dashboard-icon-3" class="img-3" width="33px" height="33px">
            </div>
        </div> -->
        <ng-container>
            <div class="menu-item mt-24" [routerLink]="['/farm']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.farmApp">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/farm-icon-1.svg" alt="farm-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/farm-icon-2.svg" alt="farm-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/farm-icon-3.svg" alt="farm-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        Farm app
                    </div>
                </div>
            </div>
            <div class="menu-item mt-24" [routerLink]="['/warehouse']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.warehouse">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/warehouse-icon-1.svg" alt="Warehouse-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/warehouse-icon-2.svg" alt="Warehouse-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/warehouse-icon-3.svg" alt="Warehouse-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        Warehouse app
                    </div>
                </div>
            </div>
            <div class="menu-item mt-24" [routerLink]="['/supply']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.supplyDemand">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/supply-icon-1.svg" alt="supply-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/supply-icon-1.svg" alt="supply-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/supply-icon-3.svg" alt="supply-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        Planning dashboard
                    </div>
                </div>
            </div>
            <div class="menu-item mt-24" [routerLink]="['/lab']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.labApp">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/lab-1.svg" alt="lab-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/lab-1.svg" alt="lab-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/lab-3.svg" alt="lab-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        Lab app
                    </div>
                </div>
            </div>
            <div class="menu-item mt-24" [routerLink]="['/quality-check']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.qualityAccess">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/quality-check-1.svg" alt="quality-check-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/quality-check-1.svg" alt="quality-check-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/quality-check-3.svg" alt="quality-check-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        Quality check
                    </div>
                </div>
            </div>
            <div class="menu-item mt-24" (click)="navigateToHse()"
            [routerLink]="['/hse']"
            [routerLinkActive]="['active']" *ngIf="appLevelAccess.accessLevel.hseAccess
            && (appLevelAccess.accessLevel.hseSummaryAccess || appLevelAccess.accessLevel.hseReportAccess)">
                <div class="img-circle-1">
                    <img src="../../../../assets/images/hse-1.svg" alt="hse-icon-1" class="img-1" width="24px" height="24px">
                    <img src="../../../../assets/images/hse-1.svg" alt="hse-icon-2" class="img-2" width="33px" height="33px">
                    <img src="../../../../assets/images/hse-3.svg" alt="hse-icon-3" class="img-3" width="33px" height="33px">
                    <div class="menu-title">
                        HSE
                    </div>
                </div>
            </div>
            <div class="menu-item pull-bottom"  data-toggle="modal" data-target="#switchModal" style="width: initial;left: calc(50% - 20px);"
            id="switchModalPopup" #switchModalPopup>
                <div class="base-name">
                    {{currentBase.baseName}}
                </div>
                <hr style="border-top: 1px solid #FFF;margin: 0px;">
                <button type="button" class="switch-btn">
                    <img src="../../../../assets/images/reload-2.svg" alt="reload-2" width="16px" height="16px" >
                   
                </button>
            </div>
        </ng-container>
    </div>
</div>

<!--switch Modal -->
<div class="modal fade" id="switchModal" tabindex="-1" role="dialog" aria-labelledby="switchModal" aria-hidden="true">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="switch-modal-header">
          <div class="header" id="exampleModalLabel">
              <img src="../../../../assets/images/reload-1.svg" alt="reload-1" width="24px"
              height="24px" >
              Switch Modal
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <div class="modal-body" style="padding:0px;overflow-y: auto;">
          <div class="bases-tile" *ngFor="let base of baseAssigned"  data-dismiss="modal"
          (click)="onUpdateBase(base.baseId,base.baseName)">
              {{base.baseName}}
          </div>
      </div>
    </div>
  </div>
</div>